import { useAuth } from "react-oidc-context";
import { authUtils } from "../common/authUtils";
import { useEffect, useState } from "react";
import { VehicleFileViewModel, vehicleFileAPI } from "../api/vehicleFileAPI";
import { Alert, Card } from "react-bootstrap";
import ErrorDisplay from "../common/ErrorDisplay";
import LoadingDisplay from "../common/LoadingDisplay";
import { Problem } from "../api/backendApi";
import { useRoutablePages } from "../common/RoutablePages";

function HomePage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Problem | undefined>(undefined);
  const [files, setFiles] = useState<VehicleFileViewModel[]>([]);
  const routes = useRoutablePages();

  const auth = useAuth();

  const notSignedIn = !auth.isAuthenticated;
  const isUser = authUtils.isUser(auth);
  const isNotValidUser = auth.isAuthenticated && !isUser;

  useEffect(() => {
    async function loadCheckedOutVehicleFiles() {
      setLoading(true);
      const data = await vehicleFileAPI.getCheckedOutVehicleFilesByUser();

      if (data.ok) {
        setError(undefined);
        setFiles(data.value);
      } else {
        setError(data.problem);
      }

      setLoading(false);
    }

    if (isUser) {
      loadCheckedOutVehicleFiles();
    }
  }, [isUser]);

  return (
    <>
      <div className="main-container-title">
        <ErrorDisplay error={error} />

        {notSignedIn && (
          <Alert variant="info">
            <Alert.Heading>Welcome</Alert.Heading>
            <hr />
            <p className="mb-0">Please sign in...</p>
          </Alert>
        )}

        {isNotValidUser && (
          <>
            <Alert variant="info">
              <Alert.Heading>Welcome</Alert.Heading>
              <hr />
              <p className="mb-0">You are signed in but we don't know you</p>
              <p className="mb-0">
                Please contact your administrator to get access to the system
              </p>
            </Alert>
          </>
        )}

        {isUser && (
          <>
            <Alert variant="info">
              <Alert.Heading>Welcome {authUtils.getName(auth)}</Alert.Heading>
              <hr />
              <p className="mb-0">You're a valid user.</p>
              <p className="mb-0">
                Here you can view the vehicle files that have been checked out
                by you.
              </p>
            </Alert>
          </>
        )}
        <LoadingDisplay loading={loading} />

        {!loading && isUser && <h2>Checked Out Vehicle Files</h2>}
      </div>
      <div className="main-container-content">
        {!loading && isUser && (
          <div className="overflow-auto">
            {files.map((file) => (
              <Card
                key={file.number}
                className="card small"
                onClick={() => routes.toVehicleFileDetails(file.number)}
                style={{ cursor: "pointer", marginTop: "1rem" }}
              >
                <Card.Header className="section dark">
                  {file.number}
                </Card.Header>
                <Card.Body>
                  <Card.Text className="section">
                    <b>{file.make}</b>
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default HomePage;
